export let augustAbbreviatedLowercase = "JKnCbb";
export default {augustAbbreviatedLowercase};